/* unplugin-vue-components disabled */import { render } from "./AskForVideo.vue?vue&type=template&id=7ce5b895&scoped=true"
import script from "./AskForVideo.vue?vue&type=script&lang=js"
export * from "./AskForVideo.vue?vue&type=script&lang=js"

import "./AskForVideo.vue?vue&type=style&index=0&id=7ce5b895&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce5b895"]])

export default __exports__